import React, { useEffect, useState } from 'react'
import { INITIAL_VALUES, mapMembersToMainAndExtra, membersEmptyState, toFormValues } from './form'
import { useErrorHandling } from 'context/errorHandling'
import { SuccessDialog } from 'components/Shared/Dialogs'
import { useHistory } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { createGroup, fetchGroup, fetchGroupMembers } from 'services/GroupsService'
import GroupsForm from 'components/Groups/GroupsForm/GroupsForm'
import { Loader } from 'components/Shared/Loader'
import { GROUP_CREATE } from 'context/auth'

export function GroupsCreateForm (props) {
  const [successDialogOpen, setSuccessDialogOpen] = useState(false)
  const [copiedGroup, setCopiedGroup] = useState()
  const [copiedMembers, setCopiedMembers] = useState(membersEmptyState)
  const [submitInProgress, setSubmitInProgress] = useState(false)

  const { t } = useTranslation()
  const history = useHistory()
  const { handleError } = useErrorHandling()

  const idOfCopiedGroup = props.location.state?.idOfCopiedGroup

  useEffect(() => {
      if (idOfCopiedGroup) {
        fetchGroup(idOfCopiedGroup)
          .then(setCopiedGroup)
          .catch(handleError)
        fetchGroupMembers(idOfCopiedGroup)
          .then(members => setCopiedMembers(mapMembersToMainAndExtra(members)))
          .catch(handleError)
      }
    }, [idOfCopiedGroup, handleError]
  )

  const handleSubmit = (newGroup, handleMembersChange) => {
    setSubmitInProgress(true)
    createGroup(newGroup)
      .then(createdGroup => handleMembersChange(createdGroup.id))
      .then(() => setSuccessDialogOpen(true))
      .catch(handleError)
      .then(() => setSubmitInProgress(false))
  }

  const handleSuccessDialogClose = () => {
    setSuccessDialogOpen(false)
    history.push('/groups')
  }

  const initialMembers = idOfCopiedGroup ? copiedMembers : membersEmptyState
  const initialValues = idOfCopiedGroup ? toFormValues(copiedGroup) : INITIAL_VALUES

  return (
    <>
      {submitInProgress && <Loader/>}
      <SuccessDialog
        content="groups.form.create.onSuccessMessage"
        open={successDialogOpen}
        onClose={handleSuccessDialogClose}
      />
      {!idOfCopiedGroup || (copiedGroup && copiedMembers) ? <GroupsForm
        onSubmit={handleSubmit}
        initialValues={initialValues}
        initialMembers={initialMembers}
        title={t('groups.form.create.title')}
        requiredPrivileges={[GROUP_CREATE]}
      /> : <Loader/>
      }
    </>
  )
}
